import { createGetFullKeyEndpointFromExisting } from '@lib';
import { getDataSecurityApplications } from './getDataSecurityApplications';

export const getDataSecurityApplicationsAll = createGetFullKeyEndpointFromExisting(
	({ ...rest }, options) => getDataSecurityApplications({
		...rest,
		ordering: 'LastUsedDate~d'
	}, options)
);
